import React from 'react';

interface Props {
  rotation?: number;
  timing?: number;
  children: React.ReactNode;
}

const Boop = ({ rotation = 0, timing = 150, children }: Props) => {
  const [isBooped, setIsBooped] = React.useState(false);

  React.useEffect(() => {
    if (!isBooped) {
      return;
    }

    const timeoutId = window.setTimeout(() => {
      setIsBooped(false);
    }, timing);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [isBooped, timing]);

  const trigger = () => {
    setIsBooped(true);
  };

  return (
    <span
      onMouseEnter={trigger}
      onClick={trigger}
      style={{
        display: 'inline-block',
        backfaceVisibility: 'hidden',
        transform: isBooped
          ? `rotate(${rotation}deg)`
          : `rotate(0deg)`,
        transition: `transform ${timing}ms`,
      }}
    >
      {children}
    </span>
  );
};

export default Boop;
